<template>
  <div class="settings-preview-col">
    <div class="settings-preview-inner ai-c">
      <div class="preview-url-row d-f ai-c jc-c g-half m-b">
        <a
          v-if="profileUrl"
          :href="profileUrl"
          target="_blank"
          class="preview-url-btn d-f ai-c g-half"
        >
          <span class="profile-url">{{ profileUrlDisplay }}</span>
          <IconBase w="15" h="15" icon-name="open" color="currentColor">
            <IconArrowUpRight2 />
          </IconBase>
        </a>
        <span v-else class="font-small mute">Set a username to preview your profile</span>
        <button
          v-if="profileUrl"
          class="preview-refresh-btn small d-f ai-c jc-c"
          @click="refreshKey++"
          title="Refresh preview"
        >
          <IconBase w="15" h="15" icon-name="refresh" color="currentColor">
            <IconRefresh />
          </IconBase>
        </button>
      </div>
      <div class="mobile-preview-phone">
        <div class="mobile-preview-wrap">
          <iframe
            v-if="profileUrl"
            :key="refreshKey"
            :src="profileUrl"
            class="mobile-preview-iframe"
            frameborder="0"
          />
          <div v-else class="d-f fd-c ai-c jc-c p mute font-small mobile-preview-empty">
            No username set
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import IconBase from "@/assets/icons/IconBase.vue";
import IconArrowUpRight2 from "@/assets/icons/IconArrowUpRight2.vue";
import IconRefresh from "@/assets/icons/IconRefresh.vue";

export default {
  name: "ProfilePreview",
  components: { IconBase, IconArrowUpRight2, IconRefresh },
  props: {
    usernameUrl: { type: String, default: null },
    refreshTrigger: { type: Number, default: 0 },
  },
  data() {
    return { refreshKey: 0 };
  },
  watch: {
    refreshTrigger() {
      this.refreshKey++;
    },
  },
  computed: {
    profileUrl() {
      if (!this.usernameUrl) return null;
      return `${window.location.origin}/${this.usernameUrl}`;
    },
    profileUrlDisplay() {
      if (!this.usernameUrl) return null;
      return `algo.am/${this.usernameUrl}`;
    },
  },
};
</script>

<style lang="scss" scoped>
@import "@/scss/_variables.scss";
@import "@/scss/_classes.scss";

.settings-preview-col {
  display: none;

  @media #{$large-screen} {
    display: block;
    flex-shrink: 0;
    align-self: stretch;
  }
}

.settings-preview-inner {
  position: sticky;
  top: calc(#{$nav-height} + #{$mg-desktop-lg});
  display: flex;
  flex-direction: column;
  gap: $mg-desktop;
}

.preview-url-btn,
.preview-refresh-btn {
  border: 1px solid rgba(255, 255, 255, 0.18);
  border-radius: 100px;
  color: inherit;
  transition: border-color 0.15s;

  &:hover {
    border-color: rgba(255, 255, 255, 0.4);
  }
}

.preview-url-btn {
  padding: 8px 14px 8px 18px;
  text-decoration: none;
  background: none;
  flex: 1;
  min-width: 0;
  overflow: hidden;
}

.preview-refresh-btn {
  padding: 8px;
  background: none;
  cursor: pointer;
  flex-shrink: 0;
}

.preview-url-row {
  max-width: 50vw;
  min-width: 0;

  @media #{$large-screen} {
    max-width: calc(70vh * 375 / 812);
  }
}

.profile-url {
  flex: 1;
  min-width: 0;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  direction: rtl;
  text-align: right;
}

.mobile-preview-phone {
  height: 70vh;
  min-height: 600px;
  aspect-ratio: 375 / 812;
  align-self: flex-start;
  border: 6px solid #000;
  border-radius: 36px;
  overflow: hidden;
  box-shadow: 0 0 0 1px rgba(255, 255, 255, 0.08), 0 24px 48px rgba(0, 0, 0, 0.5);
}

.mobile-preview-wrap {
  width: 100%;
  height: 100%;
  overflow: hidden;
}

.mobile-preview-iframe {
  width: 100%;
  height: 100%;
  border: none;
  display: block;
}

.mobile-preview-empty {
  height: 100%;
}
</style>
